import Autocomplete from '@mui/material/Autocomplete';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import React, { useContext } from 'react';

import { AttributeDefinitionsContext } from '../../AttributeDefinitionsContext';

function renderSearchInput(
  defKeyType,
  setDefKeyType,
  id,
  setId,
  idError,
  setIdError,
  dataType,
  setDataType,
  name,
  setName,
  attributeDataTypes,
  userName,
  setUserName,
  attributeName,
  setAttributeName,
  defKey,
  setDefKey,
  logSearchKeyWord,
  setLogSearchKeyWord,
) {
  const handleIdChange = (inputValue) => {
    const regex = /^[0-9\b]+$/;
    if (inputValue === '' || regex.test(inputValue)) {
      setId(inputValue);
    }
  };

  const handleSearchInputChange = (inputValue) => {
    if (defKeyType === 'defKey') {
      setDefKey(inputValue);
      setDefKeyType('defKey');
    }
    if (defKeyType === 'attributeName') {
      setAttributeName(inputValue);
      setDefKeyType('attributeName');
    } if (defKeyType === 'userName') {
      setUserName(inputValue);
      setDefKeyType('userName');
    }

    setLogSearchKeyWord(inputValue);
  };

  switch (defKeyType) {
    case 'id':
      return (
        <TextField
          variant="outlined"
          value={id}
          disabled={defKeyType === ''}
          id="search-field"
          label="ID"
          className="w-[250px]"
          onChange={(e) => handleIdChange(e.target.value)}
          InputProps={{
            style: {
              borderRadius: 30,
              backgroundColor: '#E0F0F8',
              height: '45px',
            },
          }}
        />
      );
    case 'name':
      return (
        <TextField
          variant="outlined"
          value={name}
          disabled={defKeyType === ''}
          id="search-field"
          label="Name"
          className="w-[250px]"
          onChange={(e) => setName(e.target.value)}
          InputProps={{
            style: {
              borderRadius: 30,
              backgroundColor: '#E0F0F8',
              height: '45px',
            },
          }}
        />
      );
    case 'data-type':
      return (
        <Autocomplete
          variant="outlined"
          id="data-types"
          value={dataType}
          onChange={(e, value) => setDataType(value)}
          className="w-[250px]"
          options={attributeDataTypes || []}
          getOptionLabel={(type) => (type ? type?.Description : '')}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Data Type"
              variant="outlined"
              InputProps={{
                ...params.InputProps,
                style: {
                  borderRadius: 30,
                  backgroundColor: '#E0F0F8',
                  height: '45px',
                },
              }}
            />
          )}
        />
      );
    case 'defKey':
      return (
        <TextField
          variant="outlined"
          value={defKey}
          disabled={defKeyType === ''}
          id="search-field"
          label="Def Key"
          className="w-[250px]"
          onChange={(e) => { handleSearchInputChange(e.target.value); }}
          InputProps={{
            style: {
              borderRadius: 30,
              backgroundColor: '#E0F0F8',
              height: '45px',
            },
          }}
        />
      );
    case 'attributeName':
      return (
        <TextField
          variant="outlined"
          value={attributeName}
          disabled={defKeyType === ''}
          id="search-field"
          label="Attribute Name"
          className="w-[250px]"
          onChange={(e) => { handleSearchInputChange(e.target.value); }}
          InputProps={{
            style: {
              borderRadius: 30,
              backgroundColor: '#E0F0F8',
              height: '45px',
            },
          }}
        />
      );
    case 'userName':
      return (
        <TextField
          variant="outlined"
          value={userName}
          disabled={defKeyType === ''}
          id="search-field"
          label="User Name"
          className="w-[250px]"
          onChange={(e) => { handleSearchInputChange(e.target.value); }}
          InputProps={{
            style: {
              borderRadius: 30,
              backgroundColor: '#E0F0F8',
              height: '45px',
            },
          }}
        />
      );
    default:
      return (
        <TextField
          disabled={defKeyType === ''}
          size="small"
          value=""
        />
      );
  }
}

function DefinitionKeyFilter({ tabIndex }) {
  const {
    defKeyType,
    setDefKeyType,
    id,
    setId,
    idError,
    setIdError,
    dataType,
    setDataType,
    name,
    setName,
    attributeDataTypes,
    userName,
    setUserName,
    attributeName,
    setAttributeName,
    defKey,
    setDefKey,
    logSearchKeyWord,
    setLogSearchKeyWord,
  } = useContext(AttributeDefinitionsContext);

  React.useEffect(
    () => {
      if (tabIndex === 2) {
        setDefKeyType('attributeName'); // Default to 'attributeName' for logs
      }
      if (tabIndex === 0 || tabIndex === 1) {
        setDefKeyType('name'); // Default to 'name' for attributes
      }
    },
    [tabIndex],
  );
  const handleIdTypeChange = (event) => {
    setId(null);
    setDataType(null);
    setName('');
    setDefKeyType(event.target.value);
    setUserName('');
    setAttributeName('');
    setDefKey('');
  };
  const menuItems = tabIndex === 0 || tabIndex === 1
    ? [
      { value: 'id', label: 'ID' },
      { value: 'data-type', label: 'Data Type' },
      { value: 'name', label: 'Name' },
    ]
    : [
      { value: 'attributeName', label: 'Attribute Name' },
      { value: 'defKey', label: 'Def Key' },
      { value: 'userName', label: 'User Name' },
    ];

  return (
    <Stack direction="row" gap={2}>
      <FormControl id="type-filter-select-label">
        <Select
          labelId="type-filter-select-label"
          value={defKeyType}
          onChange={(event) => handleIdTypeChange(event)}
          sx={{
            width: '200px',
            borderRadius: 30,
            height: '45px',
            backgroundColor: '#384451',
            color: 'white',
            fontWeight: 'bold',
            paddingX: 2,
            '& .MuiSelect-icon': { color: 'white' },
          }}
        >
          {menuItems.map((item) => (
            <MenuItem key={item.value} value={item.value}>
              {item.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {renderSearchInput(
        defKeyType,
        setDefKeyType,
        id,
        setId,
        idError,
        setIdError,
        dataType,
        setDataType,
        name,
        setName,
        attributeDataTypes,
        userName,
        setUserName,
        attributeName,
        setAttributeName,
        defKey,
        setDefKey,
        logSearchKeyWord,
        setLogSearchKeyWord,
      )}
    </Stack>
  );
}

export default DefinitionKeyFilter;
